import { schema } from 'normalizr';
import pick from 'lodash/pick';
import get from 'lodash/get';

import { ENTITIES_KEY_HUB } from '../constants/entityKeys';

const VIEW_URL_BASE = '/sites/view/';

export const VALID_HUB_KEYS = [
    'id',
    'title',
    'eventStart',
    'eventEnd',
    'venueName',
    'address',
    'city',
    'state',
    'zipCode',
    'country',
    'fqUrl',
    'published',
];

export const processHub = (hubData) => {
    const parsedHubData = pick(hubData, VALID_HUB_KEYS);
    const { splashHub } = hubData;

    // Store event id, and set hub id as entity's id
    parsedHubData.eventId = parsedHubData.id;
    parsedHubData.id = splashHub.id;

    parsedHubData.eventCard = get(hubData, 'eventSetting.eventCards.x2', null);

    let eventUrl = parsedHubData.fqUrl;
    if (eventUrl.indexOf('splashthat')) {
        eventUrl = eventUrl.replace('https://', VIEW_URL_BASE);
    }
    parsedHubData.eventUrl = eventUrl;

    return parsedHubData;
};

export const hubSchema = new schema.Entity(
    ENTITIES_KEY_HUB,
    {},
    {
        processStrategy: (entity) => processHub(entity),
        idAttribute: (entity) => entity.splashHub && entity.splashHub.id,
    },
);

export const hubsSchema = [hubSchema];
